'use strict';

exports.__esModule = true;

var _getEventPreprocessor = require('../../utils/getEventPreprocessor');

var _getEventPreprocessor2 = _interopRequireDefault(_getEventPreprocessor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = (0, _getEventPreprocessor2['default'])('killEvent', 'stopPropagation', 'preventDefault');


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/events/killEvent.js
// module id = 570
// module chunks = 1